import mainlogo from "../assets/images/mainlogo.svg";
import search from "../assets/images/search.svg";

const Header = () => {
    return (
        <div className="flex justify-between items-center max-h-28 ml-[50px] mt-[38px] mb-[16px] mr-[50px] overflow-hidden">
            <div className="flex items-center space-x-[11px]">
                {/* 
        todo: implement search
          <img src={search} alt="" />
          <input
            type="text"
            className="border-none bg-transparent outline-none text-[#455468] text-[14px] "
            placeholder="Search"
          /> 
        */}
            </div>
            <div className="flex items-center">
                <img src={mainlogo} alt="Financial Health Score logo" className="min-w-[221px]" />
            </div>
        </div>
    );
};
export default Header;
